import { omit } from 'lodash';
import {
  GameVariableBookTemplateState,
  GameVariableBookTemplateValues,
  PageRestitution,
  VariableRestitution,
} from '@orientaction/types';

interface GameVariableAction {
  type: string;
  payload?: unknown;
}

const INITIAL_STATE: GameVariableBookTemplateState = {
  variables: [],
  values: {
    contentForType1: 'normal',
    contentForType2: 'normal',
    citationAuthor1: '',
    citationAuthor2: '',
    citationContent1: '',
    citationContent2: '',
    p1: '',
    p2: '',
    informationEncyclopedia1: '',
    informationEncyclopedia2: '',
    page_restitution: [],
    page_restore: [],
  },
};

const gameVariableBookTemplateReducer = (
  state: GameVariableBookTemplateState = INITIAL_STATE,
  action: GameVariableAction,
): GameVariableBookTemplateState => {
  switch (action.type) {
    case 'UPDATE_FIELD': {
      const { field, value } = action.payload as { field: string; value: unknown };
      return {
        ...state,
        values: { ...state.values, [field]: value },
      };
    }

    case 'SET_ALL_VALUES':
      return {
        ...state,
        values: {
          ...state.values,
          ...(action.payload as Partial<GameVariableBookTemplateValues>),
        },
      };

    case 'RESET_VALUES':
      return INITIAL_STATE;

    case 'SET_ALL_VARIABLES':
      return {
        ...state,
        variables: action.payload as VariableRestitution[],
      };

    case 'RESET_VALUES_MODEL':
      return {
        variables: state.variables,
        values: INITIAL_STATE.values,
      };

    case 'SET_ALL_VALUES_MODEL': {
      const modelPayload = action.payload as Partial<GameVariableBookTemplateValues>;
      return {
        variables: state.variables,
        values: {
          ...omit(INITIAL_STATE.values, ['page_restitution']),
          ...modelPayload,
          page_restitution: modelPayload.page_restitution || [],
        } as GameVariableBookTemplateValues,
      };
    }

    case 'SET_PAGE_RESTITUTION':
      return {
        ...state,
        values: {
          ...state.values,
          page_restitution: action.payload as PageRestitution[],
        },
      };

    default:
      return state;
  }
};

export default gameVariableBookTemplateReducer;
